<template>
   <a-layout-content class="layout">
    <div class="header">
      <a-row>
        <a-col flex="40px">
          <a-button type="text" @click="backButtonFunc" disabled> 
            <template #icon><LeftOutlined /></template>
          </a-button>
        </a-col>
        <a-col flex="auto">
          <span class="headtitle">SCL Validation Portal</span>
        </a-col>
      </a-row>
    </div>
    <div class="content block center">
      <a-button type="primary" @click="compPaymentFunc"> {{ $t('view.home.managementPayment') }}</a-button>
      <a-button type="primary" @click="tmDiscountFunc"> {{ $t('view.home.tmDiscountPayment') }}</a-button>
      <a-button type="primary" @click="patronDiscountFunc"> {{ $t('view.home.patronDiscountPayment') }}</a-button>
    </div>
  </a-layout-content>
</template>

<script setup>
//https://stackoverflow.com/questions/6810031/css-center-element-within-a-div-element
import { onMounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { LeftOutlined } from '@ant-design/icons-vue';

const router = useRouter();
const route = useRoute()

const backButtonFunc = () => {
  console.log("click back buttton, which url should be back")
}

const compPaymentFunc = () => {
  console.log("home transaction id:" + route.query.paymentSessionId);
  router.push({ name: "comporPayment", query: {paymentSessionId: route.query.paymentSessionId}})
}

const tmDiscountFunc = () => {
  console.log("home transaction id:" + route.query.paymentSessionId);
  router.push({ name: "tmDiscount", query: {paymentSessionId: route.query.paymentSessionId,cover:route.query.cover}})
}

const patronDiscountFunc = () => {
  console.log("home transaction id:" + route.query.paymentSessionId);
  router.push({ name: "patronDiscount", query: {paymentSessionId: route.query.paymentSessionId}})
}
</script>

<style lang="less" scoped>
.layout {
  height: 100%;
  width: 100%;
  margin-bottom: 10px;
  display: flex;
  flex-flow: column;
  text-align: center;
}
.block {
    height:100%;
    width:100%;
    text-align:center;
}
.center {
 margin: auto;
}

.layout .header {
 flex: 0 1 40px;
 background-color: #d9d9d9;
 padding-top: 10px;
 font-size: medium;
 font-weight: 600;
 .headtitle
 {
  color : #2C4054;
 }
}
.layout .content {
  width: 100%;
  text-align:  center;
  flex-direction: column;
  display: flex;
  vertical-align: middle;
  .controlButton {
    margin-top: 100px;
    margin-bottom: 20px;
  }
  .textPaymentNote {
    font-size: 18px;
    text-decoration: underline;
    margin-bottom: 3px;
  }
  .textNormalNote {
    font-size: 14px;
  }
}

</style>
